module.exports = __webpack_public_path__ + "static/media/file-pdf.ec94364b.svg";